module.exports = __webpack_public_path__ + "static/media/plus-circle-accent-color.07f39bd1.svg";